import { DisconnectFromBizsolMutation } from "@/generated/graphql";
import { graphql, HttpResponse } from "msw";

export const disconnectFromBizsolHandler =
  graphql.mutation<DisconnectFromBizsolMutation>(
    "disconnectFromBizsol",
    ({ query, variables }) => {
      console.log("disconnectFromBizsolHandler: ", variables);
      return HttpResponse.json({
        data: {
          disconnectFromBizsol: {
            result: true,
          },
        },
        // Uncomment the following lines to test error handling
        // errors: [
        //   {
        //     extensions: {
        //       code: ErrorCode[ErrorCode.INTERNAL_SERVER_ERROR],
        //     },
        //   },
        // ],
      });
    }
  );
